import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => {
    // SG-14311: dark mode is disabled in the builder — the preloader always
    // renders light, ignoring stored colorScheme and the OS prefers-color-scheme.
    return {
        root: {
            position: 'absolute',
            height: '100%',
            zIndex: 99999,
            userSelect: 'none',
            background: theme.palette.background.paper,
            left: 0,
            top: 0
        },
        fixedRoot: {
            position: 'fixed'
        },
        logo: {
            width: 50,
            minWidth: 50,
            minHeight: 50,
            maxWidth: 50,
            maxHeight: 50,
            marginBottom: theme.spacing(4)
        },
        description: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(4),
            color: '#afb4b6'
        },
        hiddenDescription: {
            marginTop: theme.spacing(-1),
            opacity: 0,
            pointerEvents: 'none',
            touchAction: 'none',
            userSelect: 'none'
        },
        textCentered: {
            textAlign: 'center'
        }
    }
})
